import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { MCP_CONNECTIONS_QUERY_KEY } from './useMCPConnections';

export default function useRevokeMCPConnection(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const mutationFn = (connectionId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`mcp-connections/${connectionId}/`);
  };

  // Invalidate rather than remove: the deleted row's parent is the list the card keeps on
  // screen, and it has to re-render without the revoked connection. There is no per-connection
  // query to drop, so removing the list would only blank the card until a manual refresh.
  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(MCP_CONNECTIONS_QUERY_KEY);
    },
  });
}
